import { throwErrorMessage } from 'dashboard/store/utils/api';
import ConversationApi from '../../../../api/inbox/conversation';
import mutationTypes from '../../../mutation-types';

// Pending delayed "mark read" UI updates keyed by conversation id.
// Opening a chat schedules a 4s local unread clear; marking unread must cancel
// that timeout or the UI snaps back to read while the server is unread.
const pendingReadTimeouts = {};

const clearPendingReadUpdate = id => {
  if (pendingReadTimeouts[id]) {
    clearTimeout(pendingReadTimeouts[id]);
    delete pendingReadTimeouts[id];
  }
};

export default {
  markMessagesRead: async ({ commit }, data) => {
    try {
      const {
        data: { id, agent_last_seen_at: lastSeen },
      } = await ConversationApi.markMessageRead(data);
      clearPendingReadUpdate(id);
      pendingReadTimeouts[id] = setTimeout(() => {
        commit(mutationTypes.UPDATE_MESSAGE_UNREAD_COUNT, { id, lastSeen });
        delete pendingReadTimeouts[id];
      }, 4000);
    } catch (error) {
      // Handle error
    }
  },

  markMessagesUnread: async ({ commit }, { id }) => {
    try {
      clearPendingReadUpdate(id);
      const {
        data: { agent_last_seen_at: lastSeen, unread_count: unreadCount },
      } = await ConversationApi.markMessagesUnread({ id });
      commit(mutationTypes.UPDATE_MESSAGE_UNREAD_COUNT, {
        id,
        lastSeen,
        unreadCount,
      });
    } catch (error) {
      throwErrorMessage(error);
    }
  },
};
